import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AppState {
  isAuthenticated: boolean
}

const initialState: AppState = {
  isAuthenticated: false,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload
    },
  },
})

export const { setIsAuthenticated } = appSlice.actions
export default appSlice.reducer
